import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Helpers
import { getURLSegment, toggleDrawer } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';
import MessageThread from './MessageThread';

const Inbox = observer(class Inbox extends React.Component {
  constructor() {
    super();
    this.toggleNav = this.toggleNav.bind(this);
    this.viewThread = this.viewThread.bind(this);
  }

  componentWillMount() {
    this.state = {
      messageSid: null,
      showNav: false,
      drawerOpen: false,
      drawerContent: null,
      proctorLocationSid: null,
      examSid: null,
      sessionSid: null
    }

    this.getThreads();

    // Load thread if there’s one in the URL
    if(getURLSegment(this, 2) === 'view' && getURLSegment(this, 3)) {
      this.setState({
        messageSid: getURLSegment(this, 3)
      });
    }

    // Add class to aid styling
    document.body.className += ' inbox-body';
  }

  componentWillUnmount() {
    // Remove styling class
    document.body.className = document.body.className.replace(' inbox-body', '');
  }

  getThreads() {
    const _this = this;

    // Wait until course data exists to get threads
    const courseDelay = setInterval(function(){
      if(_this.props.store.SessionStore.courseData.sid) {
        _this.props.store.MessageStore.getThreads();
        clearInterval(courseDelay);
      }
    }, 100);
  }

  toggleNav() {
    this.setState({
      showNav: !this.state.showNav
    });
  }

  switchMailbox(e, mailbox) {
    e.preventDefault();

    // Unhighlight previously selected tab
    // const prevMailbox = document.querySelectorAll('.threads__switch .selected');
    //
    // prevMailbox.forEach(function(mailbox){
    //   if(mailbox) {
    //     mailbox.classList.remove('selected');
    //   }
    // });

    // Highlight newly selected tab
    e.target.className += ' selected';

    // Get new mailbox (not included yet since the API doesn’t exist)
  }

  viewThread(e, messageSid) {
    this.setState({
      messageSid
    });

    this.toggleNav();

    // Unhighlight any previously selected threads and
    const prevThread = document.querySelector('.thread.active');

    if(prevThread && prevThread.classList) {
      prevThread.classList.remove('active');
    }

    const thisThread = document.querySelector(`#thread-${messageSid}`);

    if(thisThread) {
      thisThread.classList.remove('thread--unread');
      thisThread.classList.add('thread--read');
    }
  }

  renderSubject(thread) {
    const { translation } = this.props;
    const { courseData } = this.props.store.SessionStore;

    let subject = null;

    if(thread.dateOption1) {
      subject = translation.subjects.session_request;
    } else if(thread.proctorApproval) {
      subject = translation.subjects.proctor_approval;
    } else if(thread.examSessionEventReport) {
      subject = translation.subjects.session_incident;
    } else if(thread.examConfiguration || (thread.examSid && thread.exam)) {
      subject = thread.exam.title;
    } else if(thread.courseSid) {
      subject = courseData.title;
    }

    if(subject) {
      return (
        <span className="thread__subject" title={subject}>{subject}</span>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;
    const { MessageStore, SessionStore} = this.props.store;
    const { threads } = MessageStore;
    const { userTimezone } = this.props.store.SessionStore;

    const thisUserSid = SessionStore.userData.userSid;

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header inbox-header">
          <div className="wrap">
            <h1 className="meta">{translation.page_title}</h1>

            {threads.length > 0 &&
              <button className="btn--outline inbox-nav-btn" onClick={this.toggleNav}>
                <icons.iconList />
                {translation.inbox_nav}
              </button>
            }
          </div>
        </header>

        <div className={`inbox ${this.state.showNav ? 'show-threads' : ''}`}>
          <section className="threads">
            <h2 className="meta">{translation.active_threads}</h2>

            {/* <ul className="toggle-list threads__switch">
              <li>
                <a
                  className="btn--neutral selected toggle-label"
                  href="#active-threads"
                  onClick={(e) => {this.switchMailbox(e, 'active')}}
                >Inbox</a>
              </li>
              <li>
                <a
                  className="btn--neutral toggle-label"
                  href="#archived-threads"
                  onClick={(e) => {this.switchMailbox(e, 'archive')}}
                >Archived</a>
              </li>
            </ul> */}

            {threads.length > 0 &&
              <ol id="active-threads" className="thread-list">
                {threads.map(
                  (thread, i) => {
                    let threadUserUnread = null;

                    if(thisUserSid === thread.initiatingUserSid) {
                      threadUserUnread = 'initiatingUserHasUnread';
                    } else {
                      threadUserUnread = 'userHasUnread';
                    }

                    return (
                      <li key={i}>
                        <article id={`thread-${thread.sid}`} className={`thread ${thread[threadUserUnread] ? 'thread--unread' : 'thread--read'}`}>
                          <header id={`thread-${i}-title`} className="thread__header">
                            <h3 className="thread__title">
                              {thread.recipientFirstName} {thread.recipientLastName}
                            </h3>

                            {this.renderSubject(thread)}
                          </header>

                          <time className="thread__date">
                            {moment.utc(thread.lastMessageDate).tz(userTimezone).format('M/D/YYYY')}
                          </time>

                          <Link
                            className="cover"
                            to={`${getURLSegment(this, 1)}/view/${thread.sid}`}
                            onClick={(e) => {this.viewThread(e, thread.sid)}}
                            aria-describedby={`thread-${i}-title`}
                          >
                            <span className="meta">{translation.view_thread}</span>
                          </Link>
                        </article>
                      </li>
                    )
                  }
                )}
              </ol>
            }
          </section>

          <section className="inbox__content">
            <h2 className="meta">{translation.inbox_content}</h2>

            {threads.length === 0 &&
              <span className="no-results">{translation.no_messages}</span>
            }

            {threads.length > 0 && this.state.messageSid &&
              <MessageThread
                messageSid={this.state.messageSid}
                inbox={this}
                parent={this}
                toggleDrawer={toggleDrawer}
                {...this.props}
              />
            }

            {threads.length > 0 && !this.state.messageSid &&
              <span className="no-results">{translation.choose_thread}</span>
            }
          </section>
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          proctorLocationSid={this.state.proctorLocationSid}
          examSid={this.state.examSid}
          sessionSid={this.state.sessionSid}
          messageSid={this.state.messageSid}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('Inbox')(Inbox);



// WEBPACK FOOTER //
// ./src/app/components/Messages/Inbox.js